<template>
    <create-button
        class="test-card card"
        :is-disabled="isAnyRequestInProgress"
        :is-in-progress="requestsProgress.store"
        :click-handler="createTest"
        :title="trans.new_test_button_title"
    >
    </create-button>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import CreateButton from "../../../utils/CreateButton";

export default {
    name: "TestListNewTestCard",
    components: {CreateButton},
    computed: {
        ...mapGetters('tests', [
            'trans',
            'requestsProgress',
            'isAnyRequestInProgress',
        ]),
    },
    methods: {
        ...mapActions('tests', [
            'createTest',
        ]),
    },
}
</script>
